<!--项目趋势图-->
<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.back()"
        >上一页</a-breadcrumb-item
      >
      <a-breadcrumb-item>项目趋势</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="c">
      <div
        class="main-container"
        id="container-1"
        v-loading="loading"
        element-loading-text="加载中"
      ></div>
      <a-empty v-if="isNoChart" description="暂无数据" />
    </div>
  </div>
</template>

<script>
import { getItemTrend, getItemTrend2 } from "@/api/report";
import * as echarts from "echarts";
export default {
  name: "curve",
  data() {
    return {
      projectName: "",
      loading: false,
      isNoChart: false,
      pageNum: 1,
      pageSize: 6,
      total: 6,
    };
  },
  created() {
    this.getData();
  },

  methods: {
    /**画折线 */
    drawLine(item) {
      var chartDom = document.getElementById(item.dom);
      this.myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
        },
        color: ["#108ee9", "#10EA6B"],
        legend: {
          data: item.legend,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: item.xData,
        },
        yAxis: {
          type: "value",
          name: item.unit,
        },
        series: item.yData,
        // 设置responsive为true
        responsive: true, //图表会根据窗口大小自动调整大小
      };
      if (item.formatter) {
        option.tooltip.formatter = item.formatter;
      }

      option && this.myChart.setOption(option);
    },

    /**获取趋势数据 */
    async getData() {
      let reqData = {
        certificateNo: this.$route.query.certificateNo, //证件号
        isAbnormal: 0, //是否异常 0-正常全部展示 1-只展示异常
        itemCode: this.$route.query.itemCode, //项目编码
        order: 0, //0-正序 1-倒序 默认倒序
      };
      this.loading = true;
      this.isNoChart = false;
      const { code, data } =
        this.$route.query.version == 2
          ? await getItemTrend2(reqData)
          : await getItemTrend(reqData);
      this.loading = false;
      if (code == 200) {
        let lineData = data || [];
        if (lineData.length > 0) {
          this.isNoChart = false;
          let name = lineData[0].itemName;
          this.projectName = name;
          this.unit = lineData[0].unit;
          let that = this;

          let item = {
            dom: "container-1",
            formatter: (params) => {
              let result = "";
              params.forEach(function (item) {
                if (item.value) {
                  result +=
                    item.marker +
                    item.seriesName +
                    ": " +
                    item.value +
                    that.unit +
                    "<br />";
                }
              });
              return name + "<br />" + result;
            },
            legend: [name],
            unit: this.unit, //单位
            xData: lineData.map((e) => {
              return e.summaryDate;
            }),

            yData: [
              {
                name,
                type: "line",
                areaStyle: {
                  opacity: 0.4,
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "rgba(16,143,234, 1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(16,143,234, 0.17)",
                    },
                  ]),
                },
                data: lineData.map((e) => e.itemValue),
              },
            ],
          };
          this.$nextTick(() => {
            this.drawLine(item);
          });
        } else {
          this.isNoChart = true;
          this.myChart && this.myChart.clear();
        }
      } else {
        this.isNoChart = true;
        this.myChart && this.myChart.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .table-striped td {
  background-color: #f0f2f5;
}
.c {
  padding: 30px 0;
  margin-top: 20px;
  .checkbox {
    text-align: right;
  }
}
.flex {
  background: #fafafa;
  border-radius: 8px;
  margin-top: 20px;
}
.main-container {
  min-height: 35vh;
}
</style>
